// A request that does not answer in time is an error for the caller. The request itself is not cancelled (the transport
// has no timeout of its own); its answer is simply no longer waited for.
export class RequestTimeoutError extends Error {
  code = 'timeout';

  constructor(ms: number) {
    super(`The request did not answer within ${ms} ms.`);
  }
}

export const withTimeout = <T, >(request: Promise<T>, ms: number): Promise<T> => new Promise<T>((resolve, reject) => {
  const timer = setTimeout(() => reject(new RequestTimeoutError(ms)), ms);

  request.then(
    value => {
      clearTimeout(timer);
      resolve(value);
    },
    error => {
      clearTimeout(timer);
      reject(error);
    }
  );
});
